export default {"src":"/_next/static/media/mobile_logo.5ddc76ee.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};